import { useEffect } from 'react';
const BASE = 'Castle Atlas';
export const usePageTitle = (title) => {
  useEffect(() => {
    // Prevent duplication — strip any existing " | Castle Atlas" before adding
    const clean = title ? title.replace(/\s*\|\s*Castle Atlas\s*/gi, '').trim() : '';
    document.title = clean ? `${clean} | ${BASE}` : `${BASE} — Master AI Prompt Engineering`;
    return () => { document.title = `${BASE} — Master AI Prompt Engineering`; };
  }, [title]);
};
export default usePageTitle;
